
export default function Video(props) {
    const { users, tracks } = props;

    return (
        <div >
            {users.length > 0 &&
                users.map((user) => {
                    if (user.videoTrack) {
                        return (
                            <div style={{ left: "30px" }} videoTrack={user.audioTrack} key={user.uid} />


                            // <Grid item xs={gridSpacing}>
                            //     <AgoraVideoPlayer
                            //         videoTrack={user.videoTrack}
                            //         key={user.uid}
                            //         style={{ height: "100%", width: "100%" }}
                            //     />
                            // </Grid>
                        );
                    } else return null;
                })}
        </div>
    );
}